export type Audience = 'PUBLIC' | 'COMMITTEE';

/** arqam's signed links download instead of opening with `?download=1`. */
export function withDownload(link: string): string {
  const url = new URL(link);
  url.searchParams.set('download', '1');
  return url.toString();
}

/**
 * «المتأخرون - المجموعة العامة 2026-10-03 (1 من 6).png». Named here: the app
 * can't read arqam's Content-Disposition (not exposed through CORS).
 */
export function imageFileName(
  audience: Audience,
  date: string,
  index: number,
  total: number,
): string {
  const group = audience === 'PUBLIC' ? 'المجموعة العامة' : 'مجموعة اللجنة';
  return `المتأخرون - ${group} ${date} (${index + 1} من ${total}).png`;
}
